import type { TypographyColors, TypographyVariants } from '../../Typography';
import { Typography } from '../../Typography';

interface EmptyStateTitleProps {
  title: string;
  variant?: TypographyVariants;
  color?: TypographyColors;
  className?: string;
}

function EmptyStateTitle(props: EmptyStateTitleProps) {
  const { title, variant, color, className } = props;
  return (
    <Typography
      className={className}
      color={color || 'text-secondary'}
      maxNumberOfLines={2}
      variant={variant}
      weight="semi-bold"
    >
      {title}
    </Typography>
  );
}

export default EmptyStateTitle;
